import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const CheckSpellingIcon = forwardRef<SVGSVGElement, Props>(
	(props, ref) => (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			ref={ref}
			{...props}
		>
			<path
				d="M4.90112 9.33334H11.1042"
				stroke="currentColor"
				strokeWidth="1"
			/>
			<path
				d="M13.9503 3.26015L13.1505 2.99356L12.8839 2.19377C12.7971 1.93541 12.3697 1.93541 12.2829 2.19377L12.0164 2.99356L11.2166 3.26015C11.0874 3.30321 11 3.42416 11 3.56031C11 3.69646 11.0874 3.81741 11.2166 3.86047L12.0164 4.12706L12.2829 4.92685C12.326 5.05603 12.4476 5.14342 12.5837 5.14342C12.7199 5.14342 12.8408 5.05603 12.8845 4.92685L13.1511 4.12706L13.9509 3.86047C14.0801 3.81741 14.1675 3.69646 14.1675 3.56031C14.1675 3.42416 14.0795 3.30321 13.9503 3.26015Z"
				fill="currentColor"
			/>
			<path
				d="M4.95857 12.6908L3.88545 12.3331L3.52774 11.26C3.41134 10.9133 2.83781 10.9133 2.72141 11.26L2.3637 12.3331L1.29058 12.6908C1.11725 12.7486 1 12.9109 1 13.0936C1 13.2762 1.11725 13.4385 1.29058 13.4963L2.3637 13.854L2.72141 14.9271C2.77919 15.1005 2.94232 15.2177 3.125 15.2177C3.30768 15.2177 3.46996 15.1005 3.52859 14.9271L3.8863 13.854L4.95942 13.4963C5.13275 13.4385 5.25 13.2762 5.25 13.0936C5.25 12.9109 5.1319 12.7486 4.95857 12.6908Z"
				fill="currentColor"
			/>
			<path
				d="M8.92899 2.40951L13.4365 13.1855C13.5985 13.5727 13.3141 14 12.8943 14C12.6557 14 12.4407 13.8557 12.3504 13.6348L7.99976 3L4.99976 10C4.30196 10 3.84126 9.27412 4.13832 8.64271L7.07085 2.40951C7.17459 2.16147 7.41714 2 7.686 2H8.31384C8.5827 2 8.82525 2.16147 8.92899 2.40951Z"
				fill="currentColor"
			/>
		</svg>
	),
)
